module.exports = __webpack_public_path__ + "img/icon_box_2_4.a7829f32.png";